import { isValidNumber } from './isValidNumber';

export const safeGetValue = (d, key) => isValidNumber(d[key]) ? d[key] : null;
